const FooterComponent=()=>{
    return(
        <footer className="footer container">
            <p>Enzo Damian Alderete, Web Developer. Todos los derechos reservados 2022.</p>
        </footer>
    )
}

export default FooterComponent;